import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import AuthGuard from '../components/feature/AuthGuard';

const HomePage = lazy(() => import('../pages/home/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const OrganizationRegisterPage = lazy(() => import('../pages/auth/register/organization/page'));
const MemberRegisterPage = lazy(() => import('../pages/auth/register/member/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const ForgotPasswordPage = lazy(() => import('../pages/auth/forgot-password/page'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password/page'));
const LevelCheckPage = lazy(() => import('../pages/level-check/page'));
const CourseFlowPage = lazy(() => import('../pages/course-flow/page'));
const AdditionalLessonApplicationPage = lazy(() => import('../pages/additional-lesson-application/page'));
const WordPoolPage = lazy(() => import('../pages/word-pool/page'));
const AddWordPage = lazy(() => import('../pages/word-pool/add-word/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/page'));
const AdminLevelCheckResultsPage = lazy(() => import('../pages/admin/level-check-results/page'));
const AdminWordPoolPage = lazy(() => import('../pages/admin/word-pool/page'));
const AdminMatchingPage = lazy(() => import('../pages/admin/matching/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));
const PlansPage = lazy(() => import('../pages/plans/page'));
const PlansSuccessPage = lazy(() => import('../pages/plans/success/page'));
const SchedulePage = lazy(() => import('../pages/schedule/page'));
const OrgSchedulePage = lazy(() => import('../pages/org/schedule/page'));
const CurriculumPage = lazy(() => import('../pages/curriculum/page'));
const PostLessonPage = lazy(() => import('../pages/post-lesson/page'));
const ProfileEditPage = lazy(() => import('../pages/profile-edit/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/register/organization', element: <OrganizationRegisterPage /> },
  { path: '/register/member', element: <MemberRegisterPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/course-flow', element: <CourseFlowPage /> },
  // 旧 readdy 外部フォームは廃止。/registration は実アプリの /register へリダイレクト。
  { path: '/registration', element: <Navigate to="/register" replace /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/word-pool', element: <WordPoolPage /> },
  { path: '/word-pool/:language', element: <WordPoolPage /> },
  { path: '/level-check', element: <LevelCheckPage /> },

  // ログイン必須
  { path: '/mypage', element: <AuthGuard><MyPage /></AuthGuard> },
  { path: '/mypage/edit', element: <AuthGuard><ProfileEditPage /></AuthGuard> },
  { path: '/additional-lesson-application', element: <AuthGuard><AdditionalLessonApplicationPage /></AuthGuard> },
  { path: '/word-pool/add-word', element: <AuthGuard><AddWordPage /></AuthGuard> },
  { path: '/plans', element: <AuthGuard><PlansPage /></AuthGuard> },
  { path: '/plans/success', element: <AuthGuard><PlansSuccessPage /></AuthGuard> },
  { path: '/schedule', element: <AuthGuard><SchedulePage /></AuthGuard> },
  // 団体管理者(org_admin = is_instructor)向け。ページ内で organization_id /
  // RLS により表示可否を判定するため AuthGuard のみ (adminOnly にはしない)。
  { path: '/org/schedule', element: <AuthGuard><OrgSchedulePage /></AuthGuard> },
  { path: '/curriculum', element: <AuthGuard><CurriculumPage /></AuthGuard> },
  { path: '/post-lesson', element: <AuthGuard><PostLessonPage /></AuthGuard> },

  // Admin専用 (URL非公開・ログインのみ。集約ダッシュボードが入口)
  { path: '/admin', element: <AuthGuard adminOnly><AdminDashboardPage /></AuthGuard> },
  { path: '/admin/level-check-results', element: <AuthGuard adminOnly><AdminLevelCheckResultsPage /></AuthGuard> },
  { path: '/admin/word-pool', element: <AuthGuard adminOnly><AdminWordPoolPage /></AuthGuard> },
  { path: '/admin/matching', element: <AuthGuard adminOnly><AdminMatchingPage /></AuthGuard> },

  { path: '*', element: <NotFoundPage /> },
];

export default routes;
